import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl,
  ogImage,
  type = 'website',
  author,
  publishedTime,
  modifiedTime
}) => {
  const baseUrl = 'https://navarisdigital.com';
  const fullTitle = title 
    ? `${title} | Navaris Digital` 
    : 'Navaris Digital - Mobile App Development, Web Development & IT Staffing';
  
  const defaultDescription = 'Leading technology solutions provider specializing in mobile application development, web development, IT staffing, and digital transformation services.';
  const metaDescription = description || defaultDescription;
  
  const defaultKeywords = 'mobile application development, web development, IT staffing, software development, custom software, cloud computing';
  const metaKeywords = keywords || defaultKeywords;
  
  const canonical = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;
  const defaultOgImage = `${baseUrl}/og-image.jpg`;
  const metaOgImage = ogImage || defaultOgImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={metaOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Navaris Digital" />
      <meta property="og:locale" content="en_US" />
      
      {/* Article specific */}
      {type === 'article' && (
        <>
          <meta property="article:publisher" content="https://www.linkedin.com/company/navaris-digital" />
          {author && <meta property="article:author" content={author} />}
          {publishedTime && <meta property="article:published_time" content={publishedTime} />}
          {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
        </>
      )}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaOgImage} />
      <meta name="twitter:site" content="@navarisdigital" />
      
      {/* LinkedIn specific */}
      <meta property="og:image:alt" content={fullTitle} />
    </Helmet>
  );
};

export default SEO;
